import { categories } from "@/mocks/melonData";

type StatusType = "确认瓜" | "落地瓜" | "盖棺定论";

export function statusTone(status: StatusType): string {
  if (status === "确认瓜") return "bg-primary-100 text-primary-800";
  if (status === "落地瓜") return "bg-accent-100 text-accent-800";
  return "bg-secondary-200/70 text-secondary-900";
}

export function statusDot(status: StatusType): string {
  if (status === "确认瓜") return "bg-primary-500";
  if (status === "落地瓜") return "bg-accent-500";
  return "bg-secondary-600";
}

export function categoryIcon(name: string): string {
  const hit = categories.find((c) => c.name === name);
  return hit ? hit.icon : "ri-question-line";
}

export function categoryTone(name: string): string {
  if (name === "影视综艺" || name === "明星动态") return "text-primary-600";
  if (name === "直播网红" || name === "音乐圈") return "text-accent-700";
  return "text-secondary-700";
}